
// Import module styles.
import "./performExercise.view.less";

// Define controllers.
window.crpu1p = {
	FormController
};

// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function FormController() {

	// Auto-save the form as people type.

	var form = document.querySelector( ".perform-exercise" );
	var submitTimer = null;

	form.addEventListener( "input", prepareForAutoSubmit );
	form.addEventListener( "submit", handleSubmit );

	// I handle the submit event on the form.
	function handleSubmit() {

		// If the user is submitting the form, we want to cancel any pending
		// background submit timer that is in-flight.
		clearTimeout( submitTimer );

	}

	// I setup the background timer for auto-save.
	function prepareForAutoSubmit() {

		clearTimeout( submitTimer );
		submitTimer = setTimeout( autoSubmitForm, 750 );

	}

	// I POST the form to the server in the background.
	function autoSubmitForm() {

		var formAction = form.getAttribute( "action" );
		var formMethod = form.getAttribute( "method" );
		var formData = new FormData( form );

		fetch(
			formAction,
			{
				method: formMethod,
				body: formData
			}
		).catch(
			( error ) => {

				// NOTE: This only represents transport errors, not HTTP error
				// responses from the server. We don't care about server
				// responses since we're only optimistically saving the form.
				console.group( "Auto submit error" );
				console.error( error );
				console.groupEnd();

			}
		);

	}

}
